import { useState, useEffect, createContext } from 'react';
import { Outlet, useMatch, useLocation } from 'react-router-dom';
import SearchBar from 'components/SearchBar/SearchBar';
import PaginatedVehicleList from './PaginatedVehicleList';

export const VehiclesSearchContext = createContext({
  searchText: '',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
  setSearchText: (_: string) => {},
});

export default function VehiclesLayout() {
  const [searchText, setSearchText] = useState('');
  const location = useLocation();
  const isDetailRoute = useMatch('/home/vehicles/:id');
  const showSearchResults = isDetailRoute && searchText.length > 0;

  // Clear search when navigating to a different route (e.g. selecting a vehicle from search results)
  useEffect(() => {
    setSearchText('');
  }, [location.pathname]);

  return (
    <VehiclesSearchContext.Provider value={{ searchText, setSearchText }}>
      <SearchBar label="Search a vehicle..." value={searchText} setQuery={setSearchText} />
      {showSearchResults ? <PaginatedVehicleList searchText={searchText} /> : null}
      <div style={{ display: showSearchResults ? 'none' : undefined }}>
        <Outlet />
      </div>
    </VehiclesSearchContext.Provider>
  );
}
